__turbopack_context__.v({
  "aligncenter": "twoColumnLayoutChildPage-module-scss-module__86B64a__aligncenter",
  "alignleft": "twoColumnLayoutChildPage-module-scss-module__86B64a__alignleft",
  "alignright": "twoColumnLayoutChildPage-module-scss-module__86B64a__alignright",
  "body": "twoColumnLayoutChildPage-module-scss-module__86B64a__body",
  "content": "twoColumnLayoutChildPage-module-scss-module__86B64a__content",
  "title": "twoColumnLayoutChildPage-module-scss-module__86B64a__title",
});
